<ng-container *ngFor="let optionalGroup of day.optionals || []">
  <div class="row" *ngFor="let optional of optionalGroup.optionals">
    <div class="col-12 pl-4 pt-2">
      <span class="overview-icons"> <app-service-icon [icon]="'landmark'" [customPath]="getActivityIcon(optional.category) || getServiceIconPath('landmark')"></app-service-icon> </span>
      <span class="text-capitalize">{{ optional.type?.toLowerCase() }}</span>
    </div>
  </div>
</ng-container>
